import { getFirebaseBackend } from '../../helpers/firebaseHelper';

const getInternalTeam = () => {
  const firebaseHelper = getFirebaseBackend();

  return new Promise(async (resolve, reject) => {
    const ectoTeam = await firebaseHelper.getTeam(process.env.REACT_APP_ECTO_ID);
    const select = [];
    Object.entries(ectoTeam).forEach(([accountId, memberInfo], index) => {
      select[index] = {
        value: memberInfo.id,
        label: `${memberInfo.name} ${memberInfo.lastName}`,
      };
    });
    resolve(select);
  });
};

export { getInternalTeam };
